import { render } from "./TextAlertModal.vue?vue&type=template&id=d84d3dde"
import script from "./TextAlertModal.vue?vue&type=script&lang=js"
export * from "./TextAlertModal.vue?vue&type=script&lang=js"

import "./TextAlertModal.vue?vue&type=style&index=0&id=d84d3dde&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__